import { useQuery } from "@tanstack/react-query";
import { SystemLicenses } from "@graylog/enterprise-api";
import i18n from "i18n";
import { defaultOnError } from "util/conditional/onError";
export const LICENSE_EVENT_DEFINITION_TEMPLATES_QUERY_KEY = "license-event-definition-templates";
const getLicenseEvenDefinitionTemplates = async () => SystemLicenses.getEventDefinitions();
const useLicenseEventDefinitionTemplates = ({ enabled } = { enabled: true }) => {
  const { data, isLoading, refetch } = useQuery({
    queryKey: [LICENSE_EVENT_DEFINITION_TEMPLATES_QUERY_KEY],
    queryFn: () => defaultOnError(
      getLicenseEvenDefinitionTemplates(),
      i18n.t("notifications.load_event_definition_templates_failed", { ns: "enterprise_license" }),
      i18n.t("notifications.load_event_definition_templates_failed_title", { ns: "enterprise_license" })
    ),
    enabled
  });
  return {
    data: data != null ? data : [],
    isLoading,
    refetch
  };
};
export default useLicenseEventDefinitionTemplates;
